<template>
    <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel">
        <a-form ref="formRef" :model="formState" :rules="rules" :label-col="{ style: { width: '110px' } }"
            :wrapper-col="{ style: { width: '300px' } }">
            <template v-if="modalConfig.role === 'qualityInspector'">
                <a-form-item label="来料日期" name="incomingMaterialDate">
                    <a-date-picker v-model:value="formState.incomingMaterialDate"
                        @change="(e, stringTime) => formState.incomingMaterialDate = stringTime" placeholder="请选择来料日期"
                        allowClear></a-date-picker>
                </a-form-item>
                <a-form-item label="物料名称" name="materialName">
                    <a-input v-model:value="formState.materialName" placeholder="请输入物料名称" allowClear></a-input>
                </a-form-item>
                <a-form-item label="物料批号" name="materialBatch">
                    <a-input v-model:value="formState.materialBatch" placeholder="请输入物料批号" allowClear></a-input>
                </a-form-item>
                <a-form-item label="物料编码" name="materialCode">
                    <a-input v-model:value="formState.materialCode" placeholder="请输入物料编码" allowClear></a-input>
                </a-form-item>
                <a-form-item label="规格型号" name="specificationAndModel">
                    <a-input v-model:value="formState.specificationAndModel" placeholder="请输入规格型号" allowClear></a-input>
                </a-form-item>
                <a-form-item label="供应商名称" name="supplierName">
                    <a-input v-model:value="formState.supplierName" placeholder="请输入供应商名称" allowClear></a-input>
                </a-form-item>
                <a-form-item label="状态" name="status">
                    <a-select v-model:value="formState.status" placeholder="请选择状态" allowClear
                        :disabled="!(formState.status === null || formState === '现场处理')">
                        <a-select-option value="现场处理">现场处理</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="问题现象" name="problemPhenomenon">
                    <after-sale-qeustion-vue :questionLists="formState.problemPhenomenon" noticeText="请输入问题现象"
                        textAreaStyle="width: 320px" ref="questionRef"></after-sale-qeustion-vue>
                </a-form-item>

                <a-form-item label="问题图片" name="picture">
                    <upload-img-vue :attachment="formState.picture" ref="uploadImg" uploadFileName="files"  :requestFn="uploadQualityInspection"></upload-img-vue>
                </a-form-item>

                <a-form-item label="问题视频" name="video">
                    <upload-video-vue :attachment="formState.video" ref="uploadVideo" uploadFileName="files" :requestFn="uploadQualityInspection"></upload-video-vue>
                </a-form-item>
            </template>

            <template v-else-if="modalConfig.role === 'supplyChain'">
                <a-form-item label="来料日期" name="incomingMaterialDate">
                    <a-date-picker v-model:value="formState.incomingMaterialDate"
                        @change="(e, stringTime) => formState.incomingMaterialDate = stringTime" placeholder="请选择来料日期"
                        disabled allowClear></a-date-picker>
                </a-form-item>

                <a-form-item label="物料名称" name="materialName">
                    <a-input v-model:value="formState.materialName" placeholder="请输入物料名称" disabled allowClear></a-input>
                </a-form-item>
                <a-form-item label="物料批号" name="materialBatch">
                    <a-input v-model:value="formState.materialBatch" placeholder="请输入物料批号" disabled
                        allowClear></a-input>
                </a-form-item>
                <a-form-item label="物料编码" name="materialCode">
                    <a-input v-model:value="formState.materialCode" placeholder="请输入物料编码" disabled allowClear></a-input>
                </a-form-item>
                <a-form-item label="规格型号" name="specificationAndModel">
                    <a-input v-model:value="formState.specificationAndModel" placeholder="请输入规格型号" disabled
                        allowClear></a-input>
                </a-form-item>
                <a-form-item label="供应商名称" name="supplierName">
                    <a-input v-model:value="formState.supplierName" placeholder="请输入供应商名称" disabled
                        allowClear></a-input>
                </a-form-item>

                <a-form-item label="问题现象" name="problemPhenomenon">
                    <after-sale-qeustion-vue :disabled="true" :questionLists="formState.problemPhenomenon"
                        textAreaStyle="width: 320px" ref="questionRef"></after-sale-qeustion-vue>
                </a-form-item>

                <a-form-item label="问题图片" name="picture" v-if="formState.picture && formState.picture !== '[]'">
                    <upload-img-vue :disabled="true" :attachment="formState.picture" ref="uploadImg"></upload-img-vue>
                </a-form-item>

                <a-form-item label="问题视频" name="video" v-if="formState.video && formState.video !== '[]'">
                    <upload-video-vue :disabled="true" :attachment="formState.video"
                        ref="uploadVideo"></upload-video-vue>
                </a-form-item>

                <div class="line">

                </div>

                <a-form-item label="通知人">
                    <staff :echoStaff="toRaw(formState).recipient ? toRaw(formState).recipient.split(',')[1] : null"
                        :echostaffUserName="toRaw(formState).recipient ? toRaw(formState).recipient.split(',')[0] : null"
                        @getChooseStaff="getChooseStaff($event, 'recipient')"></staff>
                </a-form-item>

                <a-form-item label="情况确认和分析" name="confirmationAndAnalysis">
                    <a-textarea v-model:value="formState.confirmationAndAnalysis"
                        :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="情况确认和分析" allowClear></a-textarea>
                </a-form-item>

                <a-form-item label="根本原因" name="rootCauseAnalysis">
                    <a-textarea v-model:value="formState.rootCauseAnalysis" :auto-size="{ minRows: 1, maxRows: 10 }"
                        placeholder="请输入根本原因" allowClear></a-textarea>
                </a-form-item>

                <a-form-item label="临时措施" name="temporaryMeasures">
                    <a-textarea v-model:value="formState.temporaryMeasures" :auto-size="{ minRows: 1, maxRows: 10 }"
                        placeholder="请输入临时措施" allowClear></a-textarea>
                </a-form-item>

                <a-form-item label="闭环措施" name="closedLoopMeasures">
                    <a-textarea v-model:value="formState.closedLoopMeasures" :auto-size="{ minRows: 1, maxRows: 10 }"
                        placeholder="请输入闭环措施" allowClear></a-textarea>
                </a-form-item>

                <a-form-item label="执行确认" name="implementationMeasures">
                    <a-textarea v-model:value="formState.implementationMeasures"
                        :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="请输入执行确认" allowClear>
                    </a-textarea>
                </a-form-item>

                <!-- <a-form-item label="分析部门" name="analysisDept">
                        <staff :echoStaff="formState.analysisDept?.split(',')[1]"
                            :echostaffUserName="formState.analysisDept?.split(',')[0]"
                            @getChooseStaff="getChooseStaff($event, 'analysisDept')" 
                            :appointDepartment="['工程部', '试产中心', '研发中心']"></staff>
                    </a-form-item> -->

                    
                <a-form-item label="执行部门" name="executionDept">
                    <staff :echoStaff="toRaw(formState).executionDept?.split(',')[1]"
                        :echostaffUserName="toRaw(formState).executionDept?.split(',')[0]"
                        @getChooseStaff="getChooseStaff($event, 'executionDept')"></staff>
                </a-form-item>

                <a-form-item label="状态" name="status">
                    <a-select v-model:value="formState.status" placeholder="请选择状态" allowClear>
                        <a-select-option value="分析中">分析中</a-select-option>
                        <a-select-option value="进行中">进行中</a-select-option>
                    </a-select>
                </a-form-item>

            </template>

            <a-form-item label="备注" name="notes">
                <a-textarea v-model:value="formState.notes" placeholder="备注" :auto-size="{ minRows: 1, maxRows: 10 }"
                    allowClear></a-textarea>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { toRaw, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { Toast, debounce, timeStampToTime, uploadMedia } from "@/utils";
import { saveIncomingMaterialProblem, uploadQualityInspection } from '@/request/view/dailyQualityInspection.js';
import { getEngineeringDepartment } from '@/utils/base/staff.js';
import websocket from "@/utils/base/socket";
import seriesTypeCascader from '@/components/cascader/index.vue';
import afterSaleQeustionVue from "@/views/repair/components/afterSaleQeustion.vue";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";
import staff from '@/components/chooseStaff/staff.vue';
import { useRoute } from "vue-router";

export default defineComponent({
    components: { uploadImgVue, uploadVideoVue, afterSaleQeustionVue, seriesTypeCascader, staff },
    setup(props, context) {
        const formRef = ref();
        const questionRef = ref();
        const uploadImg = ref();
        const uploadVideo = ref();
        const route = useRoute();
        const user = useStore().state.user.user;

        const useNotice = reactive({
            recipient: false,
            analysisDept: false,
            executionDept: false,
        });

        const formState = reactive({
            analysisDept: null,
            closedLoopMeasures: null,
            confirmationAndAnalysis: null,
            createUserId: null,
            executionDept: null,
            feedbackDate: null,
            feedbackDept: null,
            id: null,
            implementationMeasures: null,
            produceOrTpc: route.meta.produceOrTpc,
            incomingMaterialDate: null,
            materialBatch: null,
            materialCode: null,
            materialName: null,
            notes: null,
            picture: null,
            problemPhenomenon: null,
            recipient: null,
            rootCauseAnalysis: null,
            specificationAndModel: null,
            status: null,
            supervisionDept: null,
            supplierName: null,
            temporaryMeasures: null,
            video: null
        });

        const getAfterSaleProblemDescription = () => {
            return questionRef.value.questionList.reduce((a, b) => a + `${b.value}#`, '').replace(/(.*)#/, '$1');
        };

        const validateProblemPhenomenon = async (rule, value) => {
            const problemDescription = getAfterSaleProblemDescription().replace(/#/g, '');
            if (problemDescription === '') {
                return Promise.reject(rule.message);
            }
            return Promise.resolve();
        };

        const rules = {
            problemPhenomenon: [{ required: true, message: '请输入问题现象', validator: validateProblemPhenomenon, trigger: 'change' }],
            incomingMaterialDate: [{ required: true, message: '请选择生产日期', trigger: 'change' }],
            materialBatch: [{ required: true, message: '请输入批次号', trigger: 'change' }],
            // materialCode: [{ required: true, message: '请输入物料编码', trigger: 'change' }],
            materialName: [{ required: true, message: '请输入物料名称', trigger: 'change' }],
        };

        const modalConfig = reactive({
            role: null,
            visible: false,
            title: null,
            type: null,
        });

        const showModal = (type, options) => {
            const { title, data, role } = options;
            if (type === "edit" || type === 'analysis') {
                Object.keys(formState).forEach((key) => {
                    if (key === 'problemPhenomenon') {
                        const list = [];
                        data.problemPhenomenon.split('#').forEach((str) => {
                            list.push({
                                value: str,
                                disabled: type === 'analysis',
                            })
                        });
                        formState.problemPhenomenon = JSON.stringify(list)
                        return;
                    }
                    formState[key] = data[key];
                });
            }

            if (type === "insert") {
                formState.feedbackDate = timeStampToTime('', 'upload');
                formState.createUserId = user.id;
                formState.feedbackDept = `${user.firstLevelDepartment}${user.nickName}`;
            }

            if (type === 'analysis' && (!formState.status || formState.status === '现场处理')) {
                formState.status = '分析中';
                formState.analysisDept = `${user.firstLevelDepartment}${user.nickName}`;
            }

            modalConfig.title = title;
            modalConfig.role = role;
            modalConfig.visible = true;
            modalConfig.type = type;
        };


        const handleCancel = () => {
            resetForm();
            questionRef.value.resetList();
            modalConfig.title = null;
            modalConfig.visible = false;
            modalConfig.role = null;
            modalConfig.type = null;
            useNotice.recipient = false;
            useNotice.analysisDept = false;
            useNotice.executionDept = false;
            formState.produceOrTpc = route.meta.produceOrTpc;
        };

        const resetForm = () => {
            Object.keys(formState).forEach((key) => {
                formState[key] = null;
            });
            formRef.value.clearValidate();
        };

        // websocket通知
        const websocketNotice = (toUserId, msg) => {
            if (user.id == toUserId) return;

            return websocket.Send({
                content: msg,
                query: JSON.stringify({
                    materialName: formState.materialName,
                    materialBatch: formState.materialBatch,
                    activeKey: 'incomingMaterial',
                    type: "link",
                }),
                route: route.path,
                messageSort: '来料问题',
                toUserId,
                type: 0,
                userId: user.id,
            });
        };

        // 发送通知
        const handleSendMsg = () => {
            const step = {
                recipient: "处理来料问题",
                analysisDept: "确认和分析反馈问题",
                executionDept: "查收执行确认",
            };
            Object.keys(useNotice).forEach((key) => {
                if (useNotice[key]) {
                    const [userName, id] = formState[key].split(',');
                    let msg = `${user.nickName}推送 质检问题 请${step[key]}`;
                    websocketNotice(id, msg);
                }
            });
        };

        const handleOk = debounce(() => {
            // 售后问题
            const problemPhenomenon = getAfterSaleProblemDescription();

            const payload = Object.assign({}, formState);
            payload.problemPhenomenon = problemPhenomenon;

            formRef.value
                .validateFields()
                .then(async (res) => {
                    // 上传文件
                    if (uploadImg.value && uploadVideo.value) {
                        await uploadMedia(uploadImg, uploadVideo).then((res) => {
                            const [picture, video] = res;
                            payload.picture = picture.join(',');
                            payload.video = video.join(',');
                        });
                    }

                    switch (modalConfig.type) {
                        case 'insert':
                            const department = process.env.NODE_ENV === 'production' ? '供应链部' : '采购部';
                            await getEngineeringDepartment(department).then((res) => {
                                if (res) {
                                    const { id, nickName } = res;
                                    formState.recipient = `${nickName},${id.slice(1)}`;
                                    websocketNotice(id.slice(1), `${user.nickName}推送 质检问题 请处理来料问题`);
                                } else {
                                    Toast('warning', '网络问题消息通知未发送', 3);
                                }
                            });
                            break;
                        default:
                            break;
                    }

                    handleSendMsg();

                    saveIncomingMaterialProblem(payload).then((res) => {
                        const type = res.code === 200 ? "success" : "warning";
                        Toast(type, res.message, 3);
                        handleCancel();
                        context.emit("handleUpdateTable");
                    });
                })
                .catch((err) => {
                    if (err && err.errorFields) {
                        const [errText] = err.errorFields[0].errors;
                        Toast("warning", errText, 3);
                    }
                });
        });

        // 选择任务负责人
        const chooseStaff = (data, type) => {
            const { staffUserName, structureName } = data;
            formState[type] = `${structureName[0]}-${staffUserName[0]}`;
        };
        // 选择通知人
        const getChooseStaff = (data, key) => {
            const {
                idList,
                staffName,
                staffUserName,
                structureName,
            } = data;

            const [id] = idList;
            const [username] = staffUserName;
            const [department] = structureName;

            if (!username) return;

            const selectValue = `${username},${id},${department}`;
            if (selectValue === formState[key]) return;
            formState[key] = selectValue;
            useNotice[key] = true;
        };

        return {
            formState,
            rules,
            formRef,
            useNotice,
            showModal,
            handleCancel,
            handleOk,
            toRaw,
            chooseStaff,
            getChooseStaff,
            uploadQualityInspection,
            questionRef,
            modalConfig,
            uploadImg,
            uploadVideo,
        };
    },
});
</script>

<style lang="less" scoped>
:deep(.ant-cascader-picker-disabled) {
    color: #000;
}

.line {
    height: 2px;
    background: #ccc;
    width: 95%;
    margin-bottom: 20px;
    margin-left: 5%;
}

:deep(.ant-form-item) {
    margin-bottom: 10px;
}
</style>
